import { Await } from "@tanstack/react-router"
import { Skeleton } from "design-system/atoms/Skeleton"
import { Crumb } from "modules/shared/lib/breadcrumbs"
import { Suspense } from "react"
import { useTranslation } from "react-i18next"

type Props = {
  crumb: Crumb
}

export function CrumbTitle({ crumb }: Props) {
  const { t } = useTranslation()
  const title = crumb.getTitle(t)

  if (!title) return null

  const fallback = <Skeleton className="w-28 h-4" />

  if (title.kind === "defer") {
    return (
      <Suspense fallback={fallback}>
        <Await promise={title.value.catch(() => null)}>
          {(data) => (data ? String(data) : fallback)}
        </Await>
      </Suspense>
    )
  }

  return title.value
}
